{
  "id": "campaign-071",
  "name": "Sleepy Hole",
  "seed": "campaign:71",
  "startDir": "E",
  "mowerRule": {
    "kind": "minTier",
    "tier": 0
  },
  "rows": [
    ",_..........",
    ",_...oo.....",
    "._b.ooFo....",
    "._...oo.ss..",
    "._.....Tsss.",
    "._x..q..s.h.",
    "._..........",
    "._.W..,T....",
    "T_...,.,.b..",
    "._.W.T,.....",
    "._......q...",
    ",_,T........",
    "._.......h..",
    "._...h......",
    "._.~...T....",
    "..~.~.....**",
    "S..........*"
  ],
  "critters": [
    {
      "kind": "squirrel",
      "x": 8,
      "y": 12
    },
    {
      "kind": "squirrel",
      "x": 10,
      "y": 14
    },
    {
      "kind": "squirrel",
      "x": 2,
      "y": 9
    },
    {
      "kind": "squirrel",
      "x": 7,
      "y": 15
    },
    {
      "kind": "squirrel",
      "x": 4,
      "y": 11
    }
  ],
  "pickups": [
    {
      "kind": "gas",
      "x": 5,
      "y": 11
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 13
    },
    {
      "kind": "coin",
      "x": 4,
      "y": 15
    },
    {
      "kind": "coin",
      "x": 1,
      "y": 4
    },
    {
      "kind": "coin",
      "x": 5,
      "y": 12
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 7
    },
    {
      "kind": "coin",
      "x": 3,
      "y": 6
    },
    {
      "kind": "coin",
      "x": 11,
      "y": 10
    }
  ],
  "moles": {
    "hills": 3,
    "first": 30,
    "every": 20
  },
  "generatorVersion": 3,
  "level": 71,
  "biome": "golf",
  "par": {
    "reel": 7538,
    "push": 6036,
    "selfPropelled": 5748,
    "tractor": 4730,
    "zeroTurn": 3900,
    "fairway": 2868
  },
  "routeTries": {
    "par": {
      "reel": 0,
      "push": 20,
      "selfPropelled": 5,
      "tractor": 11,
      "zeroTurn": 20,
      "fairway": 7
    }
  }
}
